import { Injectable } from "@angular/core";
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    constructor(private toastrService: ToastrService) { }

    success(message?: string) {
        return this.toastrService.success(message);
    }

    error(message?: string) {
        return this.toastrService.error(message);
    }

    warning(message?: string) {
        return this.toastrService.warning(message);
    }

    info(message?: string) {
        return this.toastrService.info(message);
    }
}